// src/components/Modals/ModalSede/ModalSede.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";
import Modal from "@mui/joy/Modal";
import Sheet from "@mui/joy/Sheet";
import Typography from "@mui/joy/Typography";
import ModalClose from "@mui/joy/ModalClose";

import toast from "react-hot-toast";

const ModalSede = ({
  open,
  onClose,
  mode = "create", // "create" | "edit"
  initial = { idsede: null, name: "", address: "", linkMap: "", iddepartamento: null },
  onSaved, // (sede) => void
}) => {
  const [form, setForm] = useState(initial);
  const isEdit = mode === "edit";

  useEffect(() => {
    setForm(initial);
  }, [initial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEdit) {
        const { data } = await axios.put(
          `${API_BASE_URL}/updatesede/${form.idsede}`,
          {
            name: form.name,
            address: form.address,
            linkMap: form.linkMap,
            iddepartamento: form.iddepartamento,
          }
        );
        onSaved?.(data || { ...form }); // fallback por si tu backend no retorna los campos
        toast.success("Sede actualizada con éxito");
      } else {
        const { data } = await axios.post(`${API_BASE_URL}/postsede`, {
          name: form.name,
          address: form.address,
          linkMap: form.linkMap,
          iddepartamento: form.iddepartamento,
        });
        onSaved?.(data);
        toast.success("Sede creada con éxito");
      }
      onClose?.();
    } catch (error) {
      console.error("Error guardando sede:", error);
      alert("No se pudo guardar la sede.");
    }
  };

  return (
    <Modal
      aria-labelledby="sede-modal-title"
      aria-describedby="sede-modal-desc"
      open={open}
      onClose={onClose}
      className="flex justify-center items-center"
    >
      <Sheet variant="outlined" className="w-full max-w-lg p-6 bg-white rounded-md shadow-lg">
        <ModalClose variant="plain" className="m-1" onClick={onClose} />
        <Typography component="h2" id="sede-modal-title" level="h4" className="text-2xl font-semibold mb-4">
          {isEdit ? "Editar Sede" : "Nueva Sede"}
        </Typography>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Sede</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Dirección</label>
            <input
              type="text"
              name="address"
              value={form.address}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Link del Mapa</label>
            <input
              type="text"
              name="linkMap"
              value={form.linkMap}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="https://maps.google.com/..."
            />
          </div>

          {/* Mantener iddepartamento dentro del form (oculto) */}
          <input type="hidden" name="iddepartamento" value={form.iddepartamento || ""} readOnly />

          <div className="flex justify-end">
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Guardar
            </button>
          </div>
        </form>
      </Sheet>
    </Modal>
  );
};

export default ModalSede;
